define(['componentsCore'],
    function (componentsCore) {
        'use strict';

        /**
         * @constructor
         */
        function commonConfigUpdateEventAspect() {
            //dummy - implemented in Bolt only
        }

        commonConfigUpdateEventAspect.prototype = {
            registerToCommonConfigUpdated() {
                //dummy - implemented in Bolt only
            },

            unRegisterToCommonConfigUpdated() {
                //dummy - implemented in Bolt only
            }
        };

        componentsCore.siteAspectsRegistry.registerSiteAspect('commonConfigUpdateEvent', commonConfigUpdateEventAspect);
    });
